export default __webpack_public_path__ + "static/media/projects-min.d0109cbf.jpg";